import React from 'react';
import './Footer.css'; // Your styles
import logo from '../../assets/logo.webp'
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content-row-align">
        <Link to="/" className="footer-section-Image">
          <img src={logo} alt="Logo" className="footer-logo" />
        </Link>
        <div className="footer-section-industries">
          <h4>Industries</h4>

          <a href="/industriesWeServe#textile">Textile Industries</a>
          <a href="/industriesWeServe#food">Food Industries</a>
          <a href="/industriesWeServe#paint">Paint Industries</a>
          <a href="/industriesWeServe#plastic">Plastic Industries</a>
          <a href="/industriesWeServe#chemical">Chemical Industries</a>
          <a href="/industriesWeServe#soap">Soap Industries</a>
        </div>

        <div className="footer-section-products">
          <h4>Products</h4>

          <a href="/salts">Salts</a>
          <a href="/minerals">Minerals</a>
          <a href="/chemicals">Chemicals</a>
          <Link to="/sitemap">Sitemap</Link>
        </div>

        <div className="footer-section-contact">
          <h4>Contact Info</h4>
          <p>Email :<br />chemisaltcorp@gmail.com</p>
          <p>Phone :<br />+91 982-474-4940</p>
          <p>Address :<br />Office: 40 Dhanraj Nagar, Dungri Falia, Degam Road, Opp. Chandan (V) Cinema, Vapi 396195</p>
        </div>
      </div>

      <h5 className='footer-copyright-text'>&copy; 2025 Vernoxy. All rights reserved.</h5>
    </footer>
  );
};

export default Footer;
